/* <kit-category-grid>: in-place category filter (chips + sidebar), sort, load more, ?category= in the URL. */
if (!customElements.get('kit-category-grid')) {
  class KitCategoryGrid extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      if (!this.grid) return;
      this.items = [...this.grid.children];
      this.cats = [...this.querySelectorAll('[data-cat]')];
      this.chips = this.querySelector('[data-chips]');
      this.sortEl = this.querySelector('[data-sort]');
      this.more = this.querySelector('[data-more]');
      this.pageSize = Number(this.dataset.pageSize) || 24;
      this.page = 1;
      const wanted = new URLSearchParams(location.search).get('category') || '';
      this.cat = this.cats.some((c) => c.dataset.cat === wanted) ? wanted : '';

      this.cats.forEach((el) => el.addEventListener('click', (e) => {
        e.preventDefault();
        this.select(el.dataset.cat, el);
      }));
      this.sortEl?.addEventListener('change', () => { this.page = 1; this.render(); });
      this.more?.addEventListener('click', () => { this.page += 1; this.render(); });
      this.render();
    }

    select(cat, source) {
      this.cat = cat;
      this.page = 1;
      const url = new URL(location.href);
      if (cat) url.searchParams.set('category', cat); else url.searchParams.delete('category');
      history.replaceState(history.state, '', url);
      this.render();
      if (source && this.chips && this.chips.contains(source)) {
        // Keep the tapped chip in view by scrolling the chip row only (never the page horizontally).
        const left = source.offsetLeft - (this.chips.clientWidth - source.offsetWidth) / 2;
        this.chips.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
      // If the grid top has scrolled above the sticky bar, bring it back just below the bar.
      const bar = this.querySelector('.kit-cg__bar');
      const barBottom = bar && getComputedStyle(bar).position === 'sticky' ? bar.getBoundingClientRect().bottom : 0;
      const gridTop = this.grid.getBoundingClientRect().top;
      if (gridTop < barBottom) window.scrollBy({ top: gridTop - barBottom, behavior: 'smooth' });
    }

    render() {
      const sort = this.sortEl ? this.sortEl.value : 'best';
      const list = this.items.filter((el) => !this.cat || el.dataset.collections.includes(` ${this.cat} `));
      const num = (el, key) => Number(el.dataset[key]) || 0;
      list.sort((a, b) => {
        if (sort === 'price-asc') return num(a, 'price') - num(b, 'price') || num(a, 'best') - num(b, 'best');
        if (sort === 'price-desc') return num(b, 'price') - num(a, 'price') || num(a, 'best') - num(b, 'best');
        return num(a, 'best') - num(b, 'best');
      });
      const shown = this.page * this.pageSize;
      this.items.forEach((el) => { el.hidden = true; });
      list.forEach((el, i) => {
        this.grid.appendChild(el);
        el.hidden = i >= shown;
      });

      let title = this.dataset.allLabel;
      this.cats.forEach((el) => {
        const on = el.dataset.cat === this.cat;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on);
        if (on && el.dataset.title) title = el.dataset.title;
      });
      const titleEl = this.querySelector('[data-cg-title]');
      if (titleEl) titleEl.textContent = title;
      const countEl = this.querySelector('[data-cg-count]');
      if (countEl) countEl.textContent = `${list.length} ${list.length === 1 ? 'product' : 'products'}`;
      const empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = list.length > 0;
      if (this.more) this.more.hidden = list.length <= shown;
    }
  }
  customElements.define('kit-category-grid', KitCategoryGrid);
}
